// src/store/index.js
import { createStore } from 'vuex';
import users from './modules/users';
import modals from './modules/modals';

export default createStore({
  state: {
    isTheme: "dark",
    drivers: {
      pagination: {
        page: 1,
        limit: 10,
        first: 0
      },
      search: {
        query: '',
      }
    },
    dispatchers: {
      pagination: {
        page: 1,
        limit: 10,
        first: 0
      },
      filter: {
        userId: null,
        shouldFilter: false
      }
    },
  },
  getters: {
    driversPagination: state => state.drivers.pagination,
    driversSearch: state => state.drivers.search,
    dispatchersPagination: state => state.dispatchers.pagination,
    dispatchersFilter: state => state.dispatchers.filter,
    // statsSource: state => state.statsSource,
    theme: state => state.isTheme
  },
  mutations: {
    setTheme(state, theme) {
      state.isTheme = theme;
    },
    setDriversPagination(state, payload) {
      state.drivers.pagination = {
        page: payload.page,
        limit: payload.limit,
        first: payload.first
      };
    },
    setDriversSearch(state, payload) {
      state.drivers.search = {
        query: payload.query,
        // filteredData: payload.filteredData
      };
    },
    setDispatchersPagination(state, payload) {
      state.dispatchers.pagination = {
        page: payload.page,
        limit: payload.limit,
        first: payload.first
      };
    },
  },
  actions: {
    initializeTheme({ commit }) {
      const storedTheme = localStorage.getItem('isTheme');
      if (storedTheme) {
        commit('setTheme', storedTheme);
      } else {
        localStorage.setItem('isTheme', 'light');
        commit('setTheme', 'light');
      }
    },
    changeTheme({ commit }, theme) {
      localStorage.setItem('isTheme', theme);
      commit('setTheme', theme);
    },
    updateDriversPagination({ commit }, pagination) {
      commit('setDriversPagination', pagination);
    },
    updateDriversSearch({ commit }, search) {
      commit('setDriversSearch', search);
    },
    updateDispatchersPagination({ commit }, pagination) {
      commit('setDispatchersPagination', pagination);
    },
  },
  modules: {
    users,
    modals,
  }
});
